import { layout } from 'thewest/App.routing'
import { StaticRoutes, StaticRoute } from 'common/routing/page-definition'
import { getRegionalHomepage } from './get-regional-homepage'
import { getRegionalContactUsPage } from './get-regional-contact-us-page'
import { RegionalRouteConfig, regionalSiteConfig } from './regional-site-config'
import { getOurPapersRoute } from './get-our-papers'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

function getRegionalSiteStaticRoutes(
    getStaticRoutes: (
        regionalSection: Exclude<TheWestSection, 'default'>,
        config: RegionalRouteConfig
    ) => StaticRoutes<typeof layout, TheWestSection>
): StaticRoutes<typeof layout, TheWestSection> {
    return Object.keys(regionalSiteConfig).reduce<StaticRoutes<typeof layout, TheWestSection>>(
        (routes, regionalSection) => {
            const section = regionalSection as Exclude<TheWestSection, 'default'>
            const config = regionalSiteConfig[section]
            const siteRoutes = getStaticRoutes(section, config)
            return {
                ...routes,
                ...siteRoutes,
            }
        },
        {}
    )
}

export const regionalRoutes: StaticRoutes<
    typeof layout,
    TheWestSection
> = getRegionalSiteStaticRoutes((regionalSection, regionalConfig) => {
    const { mastheadTopic, regionalTopic, title, description, socialDescription } = regionalConfig

    const homepage: StaticRoute<typeof layout, TheWestSection> = services => {
        return getRegionalHomepage(services, {
            section: regionalSection,
            mastheadTopic,
            regionalTopic,
            title,
            description,
            socialDescription,
        })
    }

    const contactUsPage: StaticRoute<typeof layout, TheWestSection> = services => {
        return getRegionalContactUsPage(services, {
            section: regionalSection,
            mastheadName: title,
        })
    }

    const ourPapersPage: StaticRoute<typeof layout, TheWestSection> = services => {
        return getOurPapersRoute({
            section: regionalSection,
            getAdTargeting: services.getAdTargeting,
        })
    }

    return {
        [`/${regionalSection}`]: homepage,
        [`/${regionalSection}/contact`]: contactUsPage,
        [`/${regionalSection}/our-papers`]: ourPapersPage,
    }
})
